//@flow
import _ from 'underscore';

export type StockObject = { [sku:string]:Object};

export default class StockCollection {
  stock:StockObject;

  constructor(stockObject:?StockObject) {
    this.stock = stockObject || {};
  }

  inStock(sku:string):boolean {
    const data = this.stock[sku];
    const inStock = _.isObject(data) ? data['can_sell'] : data;

    return inStock === undefined ? true : inStock;
  }

  preSale(sku:string):boolean {
    const data = this.stock[sku];
    return _.isObject(data) ? data['pre_order'] : false;
  }
}
